<template>
    <div class="hiddenRow">
        <input
            :itemId="item && item.id"
            :value="value"
            type="hidden"
            class="form-control padding-l-bs"
        />
    </div>
</template>

<script>
    export default {
        name: "go-common-hidden",
        props: {
            value: {},
            item: {
                type: Object,
                default: () => {
                }
            }
        }
    };
</script>



// WEBPACK FOOTER //
// goingsrc/vueCom/formVue/go-hidden.vue